import { pocketbaseUrl } from './pocketbase'

/** URL pública de um arquivo de um record do PocketBase (collections com viewRule público). */
export function resolveFileUrl(collectionName: string, recordId: string, filename: string, version?: string): string {
  const cacheKey = version ? `?v=${encodeURIComponent(version)}` : ''
  return `${pocketbaseUrl}/api/files/${collectionName}/${recordId}/${filename}${cacheKey}`
}
